export const shimPathForInvestOps = (path: string) => {
  switch (path) {
    case '/support/orders': {
      return '/orders'
    }
    case '/support/automated-orders': {
      return '/automated-orders'
    }
    case '/support/money-movement': {
      return '/money-movement'
    }
    default:
      return path
  }
}
